import axios from 'axios';
import { Dispatch } from 'redux';

import { ReducerRegistry } from '../../store/reducerRegistry';

export default async function showsIndexController(
    dispatch: Dispatch,
    match,
    reducerRegistry: ReducerRegistry,
) {
    const { receiveHeroStream, receiveHeroURL, receiveLiveNotification } = require('./reducers/heroReducer');
    const { receiveFeaturedShows } = require('./reducers/featuredShowsReducer');
    const { receiveMetadata } = require('./reducers/metadataReducer');
    const { receiveShows } = require('./reducers/showsReducer');
    const reducer = require('./reducers').default;

    const [ pageDataResponse, liveNotificationResponse ] = await Promise.all([
        axios.get(`/v1/doc/${process.env.AS_SHOWS_INDEX_DOC_ID}`, {
            baseURL: process.env.AS_PAGES_API_BASE_URL,
            params: { flatten: true },
        }),
        axios.get('/live', { baseURL: process.env.AS_SCHEDULE_API_BASE_URL }),
    ]);

    const pageData = pageDataResponse.data.data.doc;

    const streamDataResponse = await axios.get(`/v1/doc/${pageData.hero_channel.doc}`, {
        baseURL: process.env.AS_PAGES_API_BASE_URL,
        params: { flatten: true },
    });

    reducerRegistry.register('showsIndex', reducer);

    dispatch(receiveFeaturedShows(pageData));
    dispatch(receiveHeroStream(streamDataResponse.data.data.doc.stream_video.id));
    dispatch(receiveHeroURL(pageData.hero_callout_link));
    dispatch(receiveMetadata(pageData));
    dispatch(receiveShows(pageData));
    dispatch(receiveLiveNotification(liveNotificationResponse.data.data));
}
